import { render, staticRenderFns } from "./MonitorModal.vue?vue&type=template&id=179884f5&scoped=true"
import script from "./MonitorModal.vue?vue&type=script&lang=js"
export * from "./MonitorModal.vue?vue&type=script&lang=js"
import style0 from "./MonitorModal.vue?vue&type=style&index=0&id=179884f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179884f5",
  null
  
)

export default component.exports